import { CustomerCredit } from "../Components/CustomerCredit/CustomerCredit";
export const ViewCredit = () => {
    return (
        <div className='container'>
            <CustomerCredit />
        </div>
    )
}